// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__Pccpe","col":"CardReaderDesc_col__1DHAC","label":"CardReaderDesc_label__3Ba7B"};